<template>
  <div>
    <div class="row col-12 text-brand-5 text-weight-bold text-body q-gutter-md">
      <div class="col-md-1 col-xs-4">
        <div class="q-ml-sm titulo-input">Unidade</div>
        <q-input
          outlined
          bg-color="brand-7"
          disable
          dense
          class="input"
          v-model="unidade.nome"
        />
      </div>
      <div class="col-md-3 col-xs-6">
        <div class="q-ml-sm titulo-input">Tipo Responsável</div>
        <q-input
          outlined
          dense
          placeholder="Ex: Responsável pela área"
          v-model="tipoResponsavel.tipo"
          class="input"
        />
      </div>
      <div>
        <div class="q-ml-sm titulo-input-radio">
          Responsável
          <span class="text-red">Tercerizado</span>
          ?
        </div>
        <q-radio
          class="q-ml-sm radio"
          :val="true"
          label="Sim"
          color="brand-4"
          v-model="tipoResponsavel.terceirizado"
        ></q-radio>
        <q-radio
          class="q-ml-lg radio"
          :val="false"
          label="Não"
          color="brand-4"
          v-model="tipoResponsavel.terceirizado"
        ></q-radio>
      </div>
      <div>
        <div class="q-ml-sm titulo-input-radio">
          Responsável
          <span class="text-red">Obrigatório</span>
          ?
        </div>
        <q-radio
          class="q-ml-sm radio"
          :val="true"
          label="Sim"
          color="brand-4"
          v-model="tipoResponsavel.obrigatorio"
        ></q-radio>
        <q-radio
          class="q-ml-lg radio"
          :val="false"
          label="Não"
          color="brand-4"
          v-model="tipoResponsavel.obrigatorio"
        ></q-radio>
      </div>
      <div>
        <p></p>
        <q-btn
          class="q-mt-sm btn"
          label="Adicionar Responsável"
          dense
          color="primary"
          icon="add_circle_outline"
          no-caps
          @click="adicionarTipoResponsavel()"
        />
      </div>
    </div>
    <span
      class="row col-12 text-brand-5 text-weight-bold q-ml-md q-mt-xl q-mb-md titulo-table"
      >Lista de Responsáveis</span
    >
    <div>
      <q-table
        table-header-class="bg-accent text-weight-bold"
        row-key="perguntaId"
        :columns="columns"
        :rows="listaTipoResponsaveis"
        :rows-per-page-options="[0]"
        dense
        :grid="$q.screen.lt.sm"
        class="tabela-tamanho-fixo"
        hide-bottom
        flat
        :loading="loading"
        color="primary"
      >
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4">
            <div
              class="row card text-grid-table text-brand-5 text-brand-5 q-pa-md q-mb-md"
            >
              <div class="row col-12 items-center justify-between">
                <span class="row col-12">
                  <span class="row col-12"
                    ><strong class="q-mr-xs">Tipo de Responsável: </strong>
                    {{ props.row.tipo }}</span
                  >
                  <span class="row col-12 q-mt-sm"
                    ><strong class="q-mr-xs">Terceirizado ?</strong>
                    <div
                      v-if="props.row.terceirizado == true"
                      class="row align items-center"
                      style="width: fit-content"
                    >
                      <span class="elipse q-mr-sm bg-positive" />
                      <div style="width: fit-content">
                        {{ "SIM" }}
                      </div>
                    </div>
                    <div
                      v-else
                      class="row align items-center"
                      style="width: fit-content"
                    >
                      <span class="elipse q-mr-sm bg-red" />
                      <div style="width: fit-content">
                        {{ "NÃO" }}
                      </div>
                    </div>
                  </span>
                  <div class="row col-12 justify-between q-mt-sm">
                    <span class="row items-center"
                      ><strong class="q-mr-xs">Obrigatório ?</strong>
                      <div
                        v-if="props.row.obrigatorio == true"
                        class="row align items-center"
                        style="width: fit-content"
                      >
                        <span class="elipse q-mr-sm bg-positive" />
                        <div style="width: fit-content" class="text-brand-5">
                          {{ "SIM" }}
                        </div>
                      </div>
                      <div
                        v-else
                        class="row align items-center"
                        style="width: fit-content"
                      >
                        <span class="elipse q-mr-sm bg-red" />
                        <div style="width: fit-content">
                          {{ "NÃO" }}
                        </div>
                      </div>
                    </span>
                    <div>
                      <q-icon
                        @click="
                          removerTipoResponsavel(props.row.tipoReponsavelId)
                        "
                        name="delete"
                        size="19px"
                        color="red"
                      />
                    </div>
                  </div>
                </span>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:body-cell-tipo="props">
          <q-td class="text-brand-4 text-weigth-bold" :props="props">
            {{ props.row.tipo }}
          </q-td>
        </template>

        <template v-slot:body-cell-tercerizado="props">
          <q-td :props="props">
            <div
              v-if="props.row.terceirizado == true"
              class="row align items-center"
              style="width: fit-content; background: #e8ffec; padding: 2px 5px"
            >
              <span class="elipse q-mr-sm bg-positive" />
              <div style="width: fit-content" class="text-bold text-brand-5">
                {{ "Sim" }}
              </div>
            </div>
            <div
              v-else
              class="row align items-center"
              style="width: fit-content; background: #ffe9e9; padding: 2px 5px"
            >
              <span class="elipse q-mr-sm bg-red" />
              <div style="width: fit-content; color: #850202" class="text-bold">
                {{ "Não" }}
              </div>
            </div>
          </q-td>
        </template>

        <template v-slot:body-cell-responsavelobrigatorio="props">
          <q-td :props="props">
            <div
              v-if="props.row.obrigatorio"
              class="row align items-center"
              style="width: fit-content; background: #e8ffec; padding: 2px 5px"
            >
              <span class="elipse q-mr-sm bg-positive" />
              <div style="width: fit-content" class="text-bold text-brand-5">
                {{ "Sim" }}
              </div>
            </div>
            <div
              v-else
              class="row align items-center"
              style="width: fit-content; background: #ffe9e9; padding: 2px 5px"
            >
              <span class="elipse q-mr-sm bg-red" />
              <div style="width: fit-content; color: #850202" class="text-bold">
                {{ "Não" }}
              </div>
            </div>
          </q-td>
        </template>
        <template v-slot:body-cell-remover="props">
          <q-td :props="props">
            <q-btn
              color="white"
              text-color="red"
              flat
              label="Remover"
              no-caps
              icon="remove_circle_outline"
              @click="removerTipoResponsavel(props.row.tipoReponsavelId)"
            />
          </q-td>
        </template>
      </q-table>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useQuasar } from "quasar";

export default {
  setup() {
    const columns = [
      {
        name: "tipo",
        label: "Tipo de Responsável",
        align: "left",
        field: "tipo",
      },
      {
        name: "tercerizado",
        label: "Tercerizado",
        align: "left",
        field: "terceirizado",
        format: (val) => (val ? "Sim" : "Não"),
      },
      {
        name: "responsavelobrigatorio",
        label: "Responsável Obrigatório",
        align: "left",
        field: "obrigatorio",
        format: (val) => (val ? "Sim" : "Não"),
      },
      {
        name: "remover",
        label: "Remover",
        align: "center",
      },
    ];
    const unidade = ref("");
    const store = useStore();
    const quasar = useQuasar();
    const router = useRouter();
    const listaTipoResponsaveis = ref();
    const tipoResponsavel = ref({
      tipo: "",
      obrigatorio: "",
      terceirizado: "",
      tipoId: "",
    });
    let loading = ref(false);

    const listarTipoResponsaveis = async () => {
      loading.value = true;
      let resposta = await store.dispatch("pdt/listarTiposResponsaveis", {
        unidadeId: unidade.value.id,
      });
      listaTipoResponsaveis.value = resposta.data.resultado.dados;
      loading.value = false;
    };

    const adicionarTipoResponsavel = async () => {
      try {
        await store.dispatch("pdt/adicionarTipoResponsavel", {
          unidadeId: unidade.value.id,
          tipo: tipoResponsavel.value.tipo,
          obrigatorio: tipoResponsavel.value.obrigatorio,
          terceirizado: tipoResponsavel.value.terceirizado,
        });
        quasar.notify({
          message: "Responsável adicionado",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarTipoResponsaveis();
        reset();
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao adicionar responsável",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const removerTipoResponsavel = async (id) => {
      tipoResponsavel.value.tipoId = id;
      try {
        await store.dispatch("pdt/removerTipoResponsavel", {
          unidadeId: unidade.value.id,
          tipoResponsavelId: tipoResponsavel.value.tipoId,
        });
        quasar.notify({
          message: "Responsável removido",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarTipoResponsaveis();
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao remover responsável",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getUnidade = () => {
      if (!store.state.org.unidadeData) {
        return;
      }
      unidade.value = store.state.org.unidadeData;
      listarTipoResponsaveis();
    };
    const voltar = () => {
      router.push({ name: "pdt-unidade" });
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        unidade.value = store.state.org.unidadeData;
        listarTipoResponsaveis();
      }
    );
    const reset = () => {
      tipoResponsavel.value.tipo = "";
      tipoResponsavel.value.obrigatorio = "";
      tipoResponsavel.value.terceirizado = "";
    };

    onMounted(getUnidade);
    return {
      columns,
      unidade,
      getUnidade,
      voltar,
      listaTipoResponsaveis,
      tipoResponsavel,
      adicionarTipoResponsavel,
      removerTipoResponsavel,
      loading,
    };
  },
};
</script>

<style scoped>
.icon {
  cursor: pointer;
}
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.titulo-table {
  font-size: 18px;
}
@media (max-width: 600px) {
  .titulo-input {
    font-size: 11px;
    margin: 0px;
  }
  .titulo-input-radio {
    font-size: 11px;
    margin-top: 12px;
  }
  .btn {
    font-size: 12px;
    margin: 0px 0px 0px 2px;
  }
  .radio {
    font-size: 11px;
  }
  .input {
    font-size: 12px;
  }
  .text-grid-table {
    font-size: 11px;
  }
  .titulo-table {
    font-size: 14px;
    margin: 30px 0px 18px 8px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .elipse {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin: -1px 7px 0px 0px;
  }
}
</style>
